export interface SSEChannel {
  addEventListener(type: string, listener: EventListener): void;
  removeEventListener(type: string, listener: EventListener): void;
  release(): void;
  close(): void;
}

interface SharedSSEChannel {
  path: string;
  es: EventSource;
  refs: number;
  closed: boolean;
}

const channels = new Map<string, SharedSSEChannel>();

export function retainSSEChannel(path = "/events"): SSEChannel | null {
  if (typeof window === "undefined") return null;
  if (typeof EventSource === "undefined") return null;

  let shared = channels.get(path);
  if (!shared || shared.closed) {
    shared = {
      path,
      es: new EventSource(path, { withCredentials: true }),
      refs: 0,
      closed: false,
    };
    channels.set(path, shared);
  }
  shared.refs += 1;

  let released = false;
  return {
    addEventListener(type, listener) {
      if (!shared.closed) {
        shared.es.addEventListener(type, listener);
      }
    },
    removeEventListener(type, listener) {
      if (!shared.closed) {
        shared.es.removeEventListener(type, listener);
      }
    },
    release() {
      if (released) return;
      released = true;
      if (shared.closed) return;
      shared.refs -= 1;
      if (shared.refs <= 0) {
        closeSharedChannel(shared);
      }
    },
    close() {
      closeSharedChannel(shared);
    },
  };
}

function closeSharedChannel(shared: SharedSSEChannel) {
  if (shared.closed) return;
  shared.closed = true;
  shared.refs = 0;
  shared.es.close();
  if (channels.get(shared.path) === shared) {
    channels.delete(shared.path);
  }
}
